import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import CustomSelect from '../Select/Select';
import TextInput from '../TextInput';

export type BankingAccountDetails = {
  accountNumber: string;
  accountType: string;
  bank: string;
  accountName: string;
};

export type customBankingAccountFormProps = React.PropsWithoutRef<{
  existingBankingAccountDetails?: any;
  handleClose: () => void;
  handleOnSubmit: (formData: any) => void;
}>;

const newBankingAccountDetails: BankingAccountDetails = {
  accountNumber: '',
  accountType: '',
  bank: '',
  accountName: '',
};

const BankingAccountForm = ({
  existingBankingAccountDetails = newBankingAccountDetails,
  handleClose,
  handleOnSubmit,
  ...props
}: customBankingAccountFormProps) => {
  const [bankingAccountDetails] = useState<BankingAccountDetails>(
    existingBankingAccountDetails
  );

  const isEditForm = bankingAccountDetails['accountNumber'] !== '';

  const validationSchema = yup.object().shape({
    accountType: yup.string().required('Type is required'),
    accountNumber: yup
      .string()
      .required('Account Number is required')
      .max(10, 'Must be no longer than 10 characters'),
    bank: yup
      .string()
      .required('Bank name is required')
      .max(245, 'Must be no longer than 245 characters'),
    accountName: yup
      .string()
      .required('Account Name is required')
      .max(245, 'Must be no longer than 245 characters'),
  });

  const options = [
    { value: 'checking', label: 'Checking' },
    { value: 'savings', label: 'Savings' },
  ];

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: bankingAccountDetails,
    resolver: yupResolver(validationSchema),
  });

  const handleSubmitForm = (formData: any) => {
    handleOnSubmit(formData);
  };

  return (
    <Form {...props}>
      <h4 className="mb-12 text-sm-20-lg-32">
        {isEditForm ? 'Edit Bank Account' : 'Add New Bank Account'}
      </h4>
      <Controller
        name={'accountType'}
        control={control}
        render={({ field }) => (
          <CustomSelect
            options={options}
            placeholder="Select account type"
            label="Account Type"
            isInvalid={!!errors.accountType}
            {...field}
          />
        )}
      />
      {errors.accountType && (
        <div className="error-message">
          <span>{errors.accountType.message}</span>
        </div>
      )}
      <Controller
      name={'bank'}
      control={control}
      render={({ field }) => (
        <TextInput
        label="Bank"
        className="mt-8"
        placeholder="Bank Name"
        isInvalid={!!errors.bank}
        {...field}
        />
      )}
      />
      {errors.bank && (
        <div className="error-message">
          <span>{errors.bank.message}</span>
        </div>
      )}
      <Controller
        name={'accountNumber'}
        control={control}
        render={({ field }) => (
          <TextInput
            label="Account Number"
            className="mt-8"
            placeholder="000000000000"
            isInvalid={!!errors.accountNumber}
            {...field}
          />
        )}
      />
      {errors.accountNumber && (
        <div className="error-message">
          <span>{errors.accountNumber.message}</span>
        </div>
      )}
      <Controller
      name={'accountName'}
      control={control}
      render={({ field }) => (
        <TextInput
          label="Give the account a name"
          className="mt-8"
          placeholder="e.g. Savings"
          isInvalid={!!errors.accountName}
          {...field}
        />
      )}
      />
      {errors.accountName && (
        <div className="error-message">
          <span>{errors.accountName.message}</span>
        </div>
      )}
      <section className="py-11 py-lg-12 d-flex justify-content-center flex-column flex-lg-row">
        <Button
          className="mt-7 mt-lg-0 me-lg-7 order-2 order-lg-1"
          variant="primary-outline"
          onMouseDown={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          className="order-1 order-lg-2"
          onClick={handleSubmit(handleSubmitForm)}
        >
          Save
        </Button>
      </section>
    </Form>
  );
};

export default BankingAccountForm;
